import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';
import { isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { FilterComponent } from './filter/filter.component';
import { RatingsResolverService } from './services/ratings.resolver.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartDateIntervalSelectorMapperService } from '@core/components/charts/chart-date-interval-selector/services/chart-date-interval-selector.mapper.service';
import { DashboardRatingsItem, DashboardRatingTasksResult, RatingsLastOpenedAtSubject } from '@core/interfaces/reports/ratings';
import { delay } from '../../../core/utils/delay';
import { ReportsService } from '../reports.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var RatingsComponent = /** @class */ (function () {
    function RatingsComponent(chartDateIntervalSelectorMapperService, fuseProgressBarService, resolverService, maintenancesApi, matDialog, route, router, reportsService, authenticationService, fuseTranslationLoaderService) {
        this.chartDateIntervalSelectorMapperService = chartDateIntervalSelectorMapperService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.resolverService = resolverService;
        this.maintenancesApi = maintenancesApi;
        this.matDialog = matDialog;
        this.route = route;
        this.router = router;
        this.reportsService = reportsService;
        this.authenticationService = authenticationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.isLoading = true;
        this.isLoadingOnlyResponseChart = true;
        this.isFiltered = false;
        this.lastOpenedAtChartChanges = new Subject();
        this.hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
        this.removeSubscriptions = new Subject();
        this.localStorageFilterValuesKey = 'ratings-dashboard-filter';
        this.autoReloadTime = 2 * 60000;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    RatingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reportsService.preserveSavedFilterValues(this.localStorageFilterValuesKey, this.filter.filterForm, this.filter.defaultFilterValues);
        this.filter.filterForm.valueChanges.pipe(takeUntil(this.removeSubscriptions), filter(function () { return _this.filter.filterForm.valid; }), debounceTime(200), switchMap(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var where;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        where = this.toQuery(this.filter.filterForm.value);
                        return [4 /*yield*/, this.updateData(where)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, where];
                }
            });
        }); })).subscribe(function (where) {
            _this.isFiltered = !isEqual(_this.filter.filterForm.value, _this.filter.defaultFilterValues);
            if (_this.isFiltered) {
                _this.setUrlAfterFilter(where);
            }
        });
        this.reload();
    };
    RatingsComponent.prototype.ngOnDestroy = function () {
        if (!this.isFiltered) {
            return;
        }
        localStorage.setItem(this.localStorageFilterValuesKey, JSON.stringify(this.filter.filterForm.value));
    };
    RatingsComponent.prototype.setUrlAfterFilter = function (where) {
        var queryParams = this.reportsService.keepOnlyChangedValuesOnQueryParams(where, this.toQuery(this.filter.defaultFilterValues));
        var url = this.router.serializeUrl(this.router.createUrlTree(['relatorios/avaliacoes'], { queryParams: tslib_1.__assign({}, queryParams) }));
        var pathName = "" + location.origin + location.pathname + "#" + url;
        window.history.pushState({}, null, pathName);
    };
    RatingsComponent.prototype.updateData = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, Promise.all([
                                this.reportsService.getAccountRatingsCount(where),
                                this.resolverService.getRatingsByQuantity(where),
                                this.resolverService.getAccountRatingsAverageByTimeline(where),
                                this.resolverService.getBestRatings(where),
                                this.resolverService.getWorstRatings(where),
                            ]).then(function (values) {
                                _this.dashboardRating = values[0];
                                _this.ratingsByQuantity = values[1];
                                _this.lineChartData = values[2];
                                _this.accountRatingsAverageByTimeline = [_this.chartDateIntervalSelectorMapperService.toLineChartFormat(_this.lineChartData.accountRatingsAverageLineChart, _this.lastOpenedAtResponse)];
                                _this.bestRatedTasks = values[3];
                                _this.worstRatedTasks = values[4];
                            }).finally(function () {
                                _this.isLoading = false;
                                _this.isLoadingOnlyResponseChart = false;
                                _this.byQuantityGraphTotalValue = _this.ratingsByQuantity.reduce(function (accumulator, current) {
                                    return accumulator + current.value;
                                }, 0);
                                _this.averageByTimelineGraphTotalValue = _this.ratingsByQuantity.reduce(function (accumulator, current) {
                                    return accumulator + current.value;
                                }, 0);
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        sentry.captureException(err_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RatingsComponent.prototype.getDateLineChartDateInterval = function (dateInterval) {
        this.lastOpenedAtResponse = dateInterval;
        if (this.filter.filterForm.invalid) {
            return;
        }
        this.updateLineChartData();
    };
    RatingsComponent.prototype.updateLineChartData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isLoadingOnlyResponseChart = true;
                        return [4 /*yield*/, delay(300)];
                    case 1:
                        _a.sent();
                        this.accountRatingsAverageByTimeline = [this.chartDateIntervalSelectorMapperService.toLineChartFormat(this.lineChartData.accountRatingsAverageLineChart, this.lastOpenedAtResponse)];
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        sentry.captureException(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoadingOnlyResponseChart = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RatingsComponent.prototype.toQuery = function (value) {
        return {
            completedAt_gte: startOfDay(value.initialDate),
            completedAt_lte: endOfDay(value.finalDate),
            companyId_in: mapIds(value.companies),
            segmentId_in: mapIds(value.segments),
            locationId_in: mapIds(value.locations),
            locationGroupId_in: mapIds(value.locationGroups),
            maintenanceTypeId_in: mapIds(value.maintenanceTypes)
        };
    };
    RatingsComponent.prototype.reload = function () {
        this.filter.filterForm.updateValueAndValidity();
    };
    RatingsComponent.prototype.autoRefresh = function (event) {
        var _this = this;
        if (event.checked) {
            this.intervalID = setInterval(function () { return _this.reload(); }, this.autoReloadTime);
            return;
        }
        clearInterval(this.intervalID);
    };
    RatingsComponent.prototype.clearFilters = function () {
        var pathName = "" + location.origin + location.pathname + "#/relatorios/avaliacoes";
        localStorage.removeItem(this.localStorageFilterValuesKey);
        window.history.pushState({}, null, pathName);
        this.filter.filterForm.patchValue(this.filter.defaultFilterValues);
    };
    RatingsComponent.prototype.openMaintenanceDialog = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogEditMaintenanceComponent, {
                                panelClass: 'dialog-edit-maintenance',
                                data: {
                                    selectedTabIndex: 2,
                                    maintenance: maintenance,
                                    isViewMode: !this.hasEditMaintenancePermission
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RatingsComponent.prototype.yAxisFormatToInteger = function (val) {
        if (val % 1 > 0) {
            return '';
        }
        return val;
    };
    RatingsComponent.prototype.yAxisFormatToDecimal = function (val) {
        if (val % 1 === 0) {
            return val + '.0';
        }
        return val;
    };
    return RatingsComponent;
}());
export { RatingsComponent };
